
import Swiper from 'swiper';

class Slider {

  constructor(elem, index = 0) {
    this.slider = elem;
    this.index = index;
    this.currentSlider = null;
	}

  initialize() {
		var el = this.slider;
    var pagination = el.find('.swiper-pagination');
    var prev = el.parent().find('.swiper-button-next');
    var next = el.parent().find('.swiper-button-prev');
    var scrollbar = el.find('.swiper-scrollbar');
    var loop = el.is('[data-loop]') || false;                // зацикливание
    var slidesPerView = el.attr('data-count') || 'auto';              // количество слайдов
    var spaceBetween = 0;                                             // расстояние между слайдами
    var freeMode = el.is('[data-freeMode]') || false;        // свободное перетаскивание
    var centeredSlides = el.is('data-centered') || false;  // центирование слайдов
    var slidesPerColumn = el.attr('data-column') || 1;                // слайды в колонках
    var effect = el.attr('data-effect') || 'slide';
    var autoHeight = el.is('[data-auto-height]') || false;
    var autoplay = '';
    let index = this.index;
    let item = el.find('[data-slider-wrapper]').children().length;
    let speed = 250;

    if (el.attr('data-autoplay')) {
      autoplay = {
        delay: 5000
      }
    }

    if (slidesPerView > 0) {
      spaceBetween = 0;
    }

    if (item < 2) {
      loop = false;
      autoplay = '';
      pagination.hide();
    }

		let breakpointMax = window.matchMedia( '(max-width: 991px)' );
    let breakpointMin = window.matchMedia( '(min-width: 992px)' );

		let mobileSlider = undefined;
		let slider = undefined;

		const breakpointChecker = function() {

			// if larger viewport and multi-row layout needed
			if ( breakpointMax.matches === true ) {

          // clean up old instances and inline styles when available
        if ( mobileSlider !== undefined ){
          mobileSlider.destroy( true, true );
        }

        // or/and do nothing
        return;

      // else if a small viewport and single column layout needed
      } else if ( breakpointMax.matches === false ) {
        // fire small viewport version of swiper
        return enableSwiper();
      }

		};

    const breakpointCheckerMin = function() {

			// if larger viewport and multi-row layout needed
			if ( breakpointMin.matches === true ) {
          // clean up old instances and inline styles when available
        if ( mobileSlider !== undefined ) {
          mobileSlider.destroy( true, true );
        }

        // or/and do nothing
        return;

      // else if a small viewport and single column layout needed
      } else if ( breakpointMin.matches === false ) {
        // fire small viewport version of swiper
        return enableSwiper();
      }

		};

    // слайдер для карточек
    if ($(el).is('[data-card-slider]')) {
      const ww = $(window).width();
      effect = (ww >= 1024) ? 'fade' : 'slide';
      speed = (ww >= 1024) ? 500 : 250;
      pagination.css('--pagination-width', `${40 / $(el).find('.swiper-slide').length}px`)
    }

		const enableSwiper = function() {
			let initIndex = 0;

			el.find('.swiper-slide').each(function(index, element) {
				if ($(element).hasClass('active')) {
					initIndex = index;
				}
			});

			mobileSlider = new Swiper(el, {
        lazy: true,
        speed: speed,
        autoHeight: autoHeight,
        loop: loop,
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        freeMode: freeMode,
        centeredSlides: centeredSlides,
        slidesPerColumn: slidesPerColumn,
        effect: effect,
        autoplay: autoplay,
        longSwipesMs: 1000,
        resistanceRatio: .5,
        fadeEffect: {
          crossFade: true
        },

        // If we need pagination
        pagination: {
          el: pagination,
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: prev,
          prevEl: next
        },

        // And if we need scrollbar
        // scrollbar: {
        //   el: scrollbar
        // }
      });

      mobileSlider.slideTo(index, 1000, false);

      // mobileSlider.update()

      $(window).on('resize orientationchange', () => {
        setTimeout(() => {
          if (mobileSlider != undefined) {
            mobileSlider.update();
          }

          if (slider != undefined) {
            slider.update()
            slider.slideTo(0, 1000, false);
          }

        }, 500);
      })

      const filterButton = $('[data-filter-hide]');
      filterButton.on('click', function() {
        mobileSlider.update()
      });
		};

		if ( el.attr('data-modile-desroy') != undefined) {
			breakpointMax.addListener(breakpointChecker);
			breakpointChecker();
		} else if (el.attr('data-desktop-desroy') != undefined) {
      breakpointMin.addListener(breakpointCheckerMin);
			breakpointCheckerMin();
    } else {
      slider = new Swiper(el, {
        lazy: true,
        speed: 250,
        autoHeight: autoHeight,
        loop: loop,
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        freeMode: freeMode,
        centeredSlides: centeredSlides,
        slidesPerColumn: slidesPerColumn,
        effect: effect,
        autoplay: autoplay,
        longSwipesMs: 1000,
        resistanceRatio: .5,
        fadeEffect: {
          crossFade: true
        },
        initialSlide: +index,

        // If we need pagination
        pagination: {
          el: pagination,
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: prev,
          prevEl: next
        },

        // And if we need scrollbar
        // scrollbar: {
        //   el: scrollbar
        // }
      });

      // slider.slideTo(index, 1000, false);
      slider.update();
      this.currentSlider = slider;

      // слайдер для карточек
      if ($(el).is('[data-card-slider]')) {
        $(el).on('mousemove', this.updateCardSlider.bind(this, el))
      }

      slider.on('slideChange', function (ev) {
        let slide = this.slides[this.realIndex];
        let slideID = slide.getAttribute('data-slide')

        if(slideID) {
          $.ajax({
            url: '/local/ajax/get_image.php',
            type: 'post',
            data: {id: slideID},
            dataType: 'html',
            success: function (data) {
              $(slide).find('img').attr('src', data);
            }
          });
        }
      });

      $(window).on('resize, orientationchange', () => {
        setTimeout(() => {
          if (mobileSlider != undefined) {
            mobileSlider.update();
          }

          if (slider != undefined) {
            slider.update()
          }
        }, 500);
      })

      const filterButton = $('[data-filter-hide]');
      filterButton.on('click', function() {
        setTimeout(() => {
          slider.update()
        }, 0);
      });
    }

    if (el.attr('data-slider-gallery') == '') {
      this.sliderArrow(el, slider);
    }

    $(window).on('resize', () => {
      this.sliderArrow(el, slider);
    })

    $('[data-slider-gallery]').find('.swiper-slide').on('mousemove', function() {
      let slide = $(this);
      let parent = slide.parent();
      let img = slide.attr('data-img');
      let card = slide.closest('[data-card]');
      let cardImg = card.find('[data-card-image]');

      let index = slide.index();
      // slider.slideTo(index, 500, false);

      parent.children().removeClass('active');
      parent.children().eq(index).addClass('active');

      cardImg.attr('src', img)
    });
	}

  updateCardSlider(el ,e) {
    // $(el).on('mousemove', (e) => {
    const ww = $(window).width();
    const that = this;
    if (ww >= 1024) {
      let sliderWidth = $(el).width();
      let curMouseHover = e.clientX - $(el).offset().left
      let slides = $(el).find('.swiper-slide').length;
      let oneSlideWidth = sliderWidth / slides
      
      let curSlide = (Math.floor(curMouseHover / oneSlideWidth) < 0) ? 0 : Math.floor(curMouseHover / oneSlideWidth)
      
      this.currentSlider.slideTo(curSlide, 500, true)
    }
    // })
  }

  destroy() {
    this.currentSlider.destroy( true, true );
  }

  sliderArrow(el, slider) {
    const that = this;
    let isIosPhone = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)

    let wrapper = isIosPhone ? el.find('.swiper-wrapper').width() : el.find('.swiper-wrapper').innerWidth();
    let items = 0;

    el.find('.swiper-slide').each(function() {
      items = isIosPhone ? items + $(this).width() : items + $(this).innerWidth()
    });

    if (wrapper < items) {
      el.parent().removeClass('arrow-hide')
    } else {
      el.parent().addClass('arrow-hide')
    }

    setTimeout(() => {
      if (that.currentSlider !== null) {
        that.currentSlider.update();
      }
    }, 500);
  }

  slidersPopup() {
    const that = this;
    var el = this.slider;
    var pagination = el.find('.swiper-pagination');
    var prev = el.parent().find('.swiper-button-next');
    var next = el.parent().find('.swiper-button-prev');
    var spaceBetween = 0;                                             // расстояние между слайдами
    let thumbs = this.slider.closest('.mfp-content').find('[data-slider-thumbs]');
    let index = this.index;
    let loop = el.is('[data-loop]') || false;

    let sliderThumbs = new Swiper(thumbs, {
      direction: "vertical",
      allowTouchMove: false,
      spaceBetween: 8,
      slidesPerView: 'auto',
      watchSlidesVisibility: true,
      watchSlidesProgress: true
    });

    this.currentSlider = new Swiper(el, {
      speed: 250,
      slidesPerView: 1,
      spaceBetween: spaceBetween,
      allowTouchMove: false,
      draggable: false,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: loop,

      // If we need pagination
      pagination: {
        el: pagination,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: prev,
        prevEl: next
      },

      thumbs: {
        swiper: sliderThumbs,
      },
    });

    this.currentSlider.slideTo(index, 1000, false);
    sliderThumbs.slideTo(index, 1000, false);

    $(window).on('resize', () => {
      that.currentSlider = new Swiper(el, {
        speed: 250,
        slidesPerView: 1,
        spaceBetween: spaceBetween,
        allowTouchMove: false,
        draggable: false,
        effect: 'fade',

        // If we need pagination
        pagination: {
          el: pagination,
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: prev,
          prevEl: next
        },

        thumbs: {
          swiper: sliderThumbs,
        },
      });
      that.currentSlider.slideTo(index, 1000, false);
      that.currentSlider.update()
    })
  }

  slideTo(index) {
    console.log(this.currentSlider);
    this.currentSlider.slideTo(index, 100, false);
    this.currentSlider.update()
  }
}

export {Slider};

$(function () {
  window.Slider = Slider;
});

$(window).on('load', function() {
  let sliders = [];

  if ($('[data-slider]').length > 0) {
		$('[data-slider]').each(function(i) {
      if ($(this).attr('data-slider') != 'loading') {
        sliders[i] = new Slider($(this));
        sliders[i].initialize();
        $(this).attr('data-initialize', 'true')
      }
		});
	}
});
